export default __webpack_public_path__ + "static/media/about.76a6e6ee.jpg";